"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventTypes = void 0;
var EventTypes = exports.EventTypes = {
  //header
  change_variant: 'header_change_variant',
  save: 'header_save_configuration',
  load: 'header_load_configuration_open_dialog',
  load_request: 'header_load_configuration_request',
  mail: 'header_email',
  picture_as_pdf: 'header_pdf',
  //preview
  preview_open: 'preview_open',
  preview_close: 'preview_close',
  //add image
  add_image: 'image_add',
  uploaded_file_type: 'image_edit_upload_file',
  //image_edit
  edit_image: 'image_edit',
  image_edit_options: 'image_edit_option_usage',
  image_colorize: 'image_edit_colorize',
  image_background: 'image_edit_remove_background',
  image_edit_colorize_found_colors: 'image_edit_colorize_select_color_amount',
  image_edit_colorize_color: 'image_edit_colorize_select_color',
  //object_controls
  align_horizontal_center: 'object_controls_align_center_horizontal',
  align_vertical_center: 'object_controls_align_center_vertical',
  align_move_down: 'object_controls_level_down',
  align_move_up: 'object_controls_level_up',
  //image_gallery
  upload_new: 'image_gallery_upload_new',
  image_thumbnail_select: 'image_gallery_select_gallery_image',
  //add text
  add_text: 'text_controls_add',
  //text_controls
  text_bold: 'text_controls_bold',
  text_italic: 'text_controls_italic',
  text_align_left: 'text_controls_align_left',
  text_align_center: 'text_controls_align_center',
  text_align_right: 'text_controls_align_right',
  text_align_justify: 'text_controls_align_justify',
  text_font: 'text_controls_select_font',
  //color palette
  text_color: ' text_controls_select_color',
  //design_area
  design_area_switch: 'edit_design_change_design_area',
  //design_production
  design_production_switch: 'edit_design_change_design_production_method',
  //summary
  add_to_cart: 'accept_design_open_dialog',
  selected_amounts: 'accept_design_approve',
  //calculation_widget
  widget_print_view: 'calculation_widget_pdf ',
  widget_open_configurator: 'calculation_widget_open_configurator',
  widget_change_amount: 'calculation_widget_change_amount',
  widget_add_design_area: 'calculation_widget_add_design_area',
  widget_remove_design_area: 'calculation_widget_remove_design_area',
  widget_change_design_production_method: 'calculation_widget_change_design_production_method',
  //on_load
  load_item: 'load_item',
  //component and option_selection
  select_component: 'components_select_component',
  switch_option: 'components_select_option',
  //mode switch
  configuration_mode_switch: 'configuration_mode_switch',
  //creator summay
  configuration_selected_amounts: 'accept_configuration_approve',
  configuration_add_to_cart: 'accept_configuration_open_dialog'
};